module.exports = __webpack_public_path__ + "img/tank.3949ea49.svg";